
import Vue from "vue"

export default Vue.extend({
  name: "ProgressGlobalHeader",
  props: {
    globalProgress: {
      type: Number,
      default: 0,
    },
    userName: {
      type: String,
      default: "",
    },
  },
  computed: {
    welcomeText(): string {
      if (!this.userName) {
        return this.$vuetify.lang.t("$vuetify.progression_welcome_short")
      }
      const template = this.$vuetify.lang.t("$vuetify.progression_welcome")
      return template.replace("{name}", this.userName)
    },
  },
})
